import { PlatformInfo, RoleInfo } from "../../types/game";
import axios from "../http";
import { BaseReply } from "../type";
// TODO: 需要在 shared/types 中定义这些类型，或从正确的路径导入
// import type { BindGame, Gift, PlatformInfo, RoleInfo, SubscribeCircleType, UserBaseInfoType, userloginType } from "@/types";

// 获取腾讯IM cors秘钥
export function getTCOSKey() {
  return axios({
    method: "get",
    url: "/user/v1/cos/tmp_secret_key"
  });
}

//获取app下载链接
export function getAppLink(channel_type?: number) {
  return axios<BaseReply<{ package_url: string }>>({
    method: "get",
    url: "/server/v1/official/package",
    params: { channel_type }
  });
}
//获取个人信息
export function getBaseInfo() {
  return axios<BaseReply<any>>({
    method: "get",
    url: "/user/v1/base_info"
  });
}

// 获取游戏内角色列表
export function getRoleList(data: { server_id: string }) {
  return axios<
    BaseReply<{
      platform_list: PlatformInfo[];
      role_list: RoleInfo[];
      mobile: string;
    }>
  >({
    method: "get",
    url: "/circle/v1/server/platform_list",
    params: data
  });
}
